/**
 * 微信授权相关工具函数
 * Created by PeakXin on 2025/10/29
 * Optimized on 2025/11/03
 */
import Cookies from 'js-cookie'

/* ----------------------------
 * 常量定义
 * ---------------------------- */
const TOKEN_KEY = 'Wechat-Token'
const TOKEN_EXPIRES = 30 // Token 默认有效期（天）

const WECHAT_CONFIG = {
  BASE_AUTH_URL: 'https://open.pennonedu.com/wechat/official_account',
  PARAMS_TO_CLEAN: ['code', 'state', 'appid']
}

/* ----------------------------
 * Token 操作
 * ---------------------------- */

/**
 * 获取 Token
 * @returns {string | undefined}
 */
export const getToken = () => Cookies.get(TOKEN_KEY)

/**
 * 设置 Token
 * @param {string} token
 * @param {number} [expires=TOKEN_EXPIRES]
 */
export const setToken = (token, expires = TOKEN_EXPIRES) => {
  if (!token) {
    console.warn('[WxAuth] setToken 调用失败：token 为空')
    return
  }
  return Cookies.set(TOKEN_KEY, token, { expires })
}

/**
 * 移除 Token
 */
export const removeToken = () => Cookies.remove(TOKEN_KEY)

/* ----------------------------
 * URL 参数操作
 * ---------------------------- */

/**
 * 清理 URL 中的指定参数
 * @param {string} url - 原始 URL
 * @param {string[]} params - 要删除的参数
 * @returns {string} 清理后的 URL
 */
const removeUrlParams = (url, params = []) => {
  try {
    const urlObj = new URL(url)
    params.forEach(param => urlObj.searchParams.delete(param))
    return urlObj.toString()
  } catch (err) {
    console.error('[WxAuth] URL 处理失败:', err)
    return url
  }
}

/* ----------------------------
 * 微信授权跳转
 * ---------------------------- */

/**
 * 跳转到微信授权页面
 * @param {string} [customRedirectUrl] - 自定义回调地址（可选）
 */
export const redirectToWechatAuth = (customRedirectUrl = '') => {
  if (typeof window === 'undefined') {
    console.warn('[WxAuth] redirectToWechatAuth 在非浏览器环境中调用被忽略')
    return
  }

  try {
    const currentUrl = customRedirectUrl || window.location.href
    const cleanUrl = removeUrlParams(currentUrl, WECHAT_CONFIG.PARAMS_TO_CLEAN)

    const redirect = encodeURIComponent(cleanUrl)
    const authUrl = `${WECHAT_CONFIG.BASE_AUTH_URL}?redirect=${redirect}`

    window.location.replace(authUrl)
  } catch (err) {
    console.error('[WxAuth] 微信授权跳转失败:', err)
    // 可以在这里调用全局 Toast 提示
    // Toast.fail('跳转失败，请稍后重试')
  }
}
